module.exports = __webpack_public_path__ + "img/sycWhiteIpFn.18fe448b.png";